module.exports = __webpack_public_path__ + "media/services/smart-finance-bd6e1e84.svg";